import { createBrowserRouter } from 'react-router';
import { faqRoutes } from '../features/faq';
import { homeRoutes } from '../features/home';
import { notFoundRoutes } from '../features/notFound';
import { supportRoutes } from '../features/support';
import { MainLayout } from '../layouts';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: MainLayout,
    children: [...homeRoutes, ...supportRoutes, ...faqRoutes, ...notFoundRoutes],
  },
]);
